import { HttpResponse as BackendHttpResponse } from '@/backend-api/Api';

export enum ResponseType {
    SUCCESS = 'success',
    ERROR = 'error',
}

export interface SuccessResponse<T = void> {
    status: 'success';
    data: T;
}

interface SuccessResponseVoid {
    // todo dont call it void
    status: ResponseType.SUCCESS;
}

export interface ErrorResponse {
    status: 'error';
    error: string;
}

export type ActionResponse<T = void> = SuccessResponse<T> | ErrorResponse;
export type ActionResponseVoid = SuccessResponseVoid | ErrorResponse;

export type ActionFnData<
    TFn extends (...args: any[]) => Promise<ActionResponse<unknown>>,
    TReturn = Awaited<ReturnType<TFn>>,
> = TReturn extends SuccessResponse<unknown> ? TReturn['data'] : never;

export const actionSuccess = <T>(data: T): SuccessResponse<T> => ({ status: 'success', data });
export const actionError = (prefix: string | undefined, error: unknown): ErrorResponse => ({
    status: 'error',
    error: prefix != null ? `${prefix}: ${error}` : `${error}`,
});

export function getResponseData<T>(response: ActionResponse<T> | BackendHttpResponse<T>): T {
    if (response.status === 'error') {
        throw new Error(response.error);
    }
    return response.data;
}

export interface PaginationRequest {
    page?: number;
    pageSize?: number;
}

export interface PaginationResponse<T> {
    totalRecords: number;
    currentPage: number;
    totalPages: number;
    items: T[];
}

export type PaginatedResponse<T> = {
    items: T[];
    meta: {
        total: number; // total items
        page: number; // current page
        pageSize: number; // items per page
        totalPages: number; // total number of pages
        hasNextPage: boolean;
        hasPreviousPage: boolean;
    };
};

export type PaginationDTO = {
    page: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
};

export type PaginationFilterResponse<T, F> = {
    pagination: PaginationDTO;
    data: T[];
    filterOptions: F;
};
